<template>
    <div id="web-link">
        Please wait while we load your content...
    </div>
</template>
<script>
export default {
    name: 'WebLink',
    props: ['boosterData'],
    mounted() {
        let _this = this
        setTimeout(function() {
            window.location.assign(_this.boosterData.url);
        }, 3000)
    }
}
</script>